import api from "../api/axios";

export const fetchChatMessages = async (tournamentId: string) => {
  const response = await api.get(`/chat/${tournamentId}/messages`);
  return response.data.messages;
};

export const sendChatMessage = async (tournamentId: string, message: string) => {
  const response = await api.post(`/chat/${tournamentId}/message`, { message });
  return response.data.message;
};
